// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './TechnicalCard.scss';

export default class TechnicalCard extends Component{
  constructor(props) {
    super(props);

  }

  render() {

    return (
      <a href={this.props.pdf} download className='technical-link'>
        <div className="technical-card-button">
        Karta techniczna
        </div>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TechnicalCard/TechnicalCard.js